import AlertManagerIcon from './component'

export default AlertManagerIcon
